module.exports = __webpack_public_path__ + "static/media/workplaceCopy.c98a1e40.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/workplaceCopy.png
// module id = 1984
// module chunks = 0